import { A } from "@solidjs/router";
import type { Component } from "solid-js";
import { Container, ContainerHeader } from "@/components/shared/Container";
import { Button } from "@/components/ui/button";
import { RootLayout } from "@/domains/auth/routes/layout";

export const FakeJobOffer: Component = () => {
  return (
    <RootLayout>
      <Container>
        <ContainerHeader>
          <div class="space-y-2">
            <h1 class="text-2xl font-bold">Fake Job Offer</h1>
            <p>
              This is a fake job offer. It is not real and is not a real job.
            </p>
          </div>
        </ContainerHeader>
        <Button as={A} href="/">
          Back to Home
        </Button>
      </Container>
    </RootLayout>
  );
};
